export default "__VITE_ASSET__BQqVxEoc__"